import {call, put, select, take} from "redux-saga/effects";
import {enterQuestion, leaveQuestion} from "../../questions/actions";
import fetchQuestion from "./fetchQuestion";
import {IApplicationState} from "../../index";
import {setQuestion} from "../actions";
import {addScore} from "../../player/actions";

export default function* loadAndShowQuestion(questionId: number, onShow?: () => void) {
    yield put(enterQuestion(questionId));

    const isSucceed = yield call(fetchQuestion, questionId);
    if (!isSucceed) {
        return false;
    }

    const questionIsLoaded = yield select(({ game } : IApplicationState) => !!game.questions[questionId]);
    if (!questionIsLoaded) {
        return false;
    }

    yield put(setQuestion(questionId));

    if (onShow) {
        yield call(onShow);
    }

    const isAlreadyAnswered = yield select(({ questions } : IApplicationState) => {
        const progress = questions.progress[questionId];

        return (progress && (progress.attempts < 0 || progress.isTimeoutExpired)) || false;
    });

    const {payload: progress} = yield take(leaveQuestion);

    if (!isAlreadyAnswered && progress && progress.isRight && progress.score > 0) {
        yield put(addScore(progress.score, "answered_question_right"));
    }

    return true;
}